import { format, parseISO, startOfDay } from 'date-fns'

export const getLocalDate = (): Date => {
  return startOfDay(new Date())
}

export const getIso8601Date = (date: Date | number = new Date()): string => {
  return format(date, 'yyyy-MM-dd')
}

export const getIso8601DateFromDateTime = (dateTime: string): string => {
  return getIso8601Date(parseISO(dateTime))
}
